/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import StarRatings from 'react-star-ratings';
import { createRatingReview, updateRatingAndReview } from '../../../services/operations/courseApi';
import { setReviewModal } from '../../../redux/slices/viewCourseSlice';

const CourseReviewModal = () => {
    const { user } = useSelector(state => state.profile);
    const [rating, setRating] = useState(0);
    const [reviewUpdating, setReviewUpdating] = useState({});
    const { courseId } = useParams();
    const dispatch = useDispatch();
    const { courseEntireData } = useSelector(state => state.viewCourse)
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm();

    const changeRatingHandler = (newRating) => {
        setRating(newRating);
        setValue("courseRating", newRating);
    }
    const onSubmit = (data) => {
        if (reviewUpdating._id) {
            const reviewId = reviewUpdating._id;
            dispatch(updateRatingAndReview(data.courseRating, data.courseExperience, courseId, reviewId, dispatch));
        } else {
            dispatch(createRatingReview(data.courseRating, data.courseExperience, courseId, dispatch));
        }
    }

    useEffect(() => {
        setValue("courseExperience", "");
        setValue("courseRating", 0);

        const userReview = courseEntireData?.ratingAndReviews
            .filter(review => review?.user === user?._id);

        if (userReview.length > 0) {
            const reviewToUpdate = userReview[0];

            setReviewUpdating(reviewToUpdate);
            setRating(reviewToUpdate?.rating);
            setValue("courseExperience", `${reviewToUpdate?.review}`);
            setValue("courseRating", reviewToUpdate?.rating);
        }

    }, [])

    return (
        <div className='text-richblack-5 fixed inset-0 z-[1000] !mt-0 grid h-screen w-screen place-items-center overflow-auto bg-white bg-opacity-10 backdrop-blur-sm'>
            <div className='my-10 w-11/12 max-w-[700px] rounded-lg border border-richblack-400 bg-richblack-800'>
                <div className='flex items-center justify-between rounded-t-lg bg-richblack-700 p-5'>
                    <p className='text-xl font-semibold text-richblack-5'>
                        Add Review
                    </p>
                    <button
                        className='text-[25px] font-extrabold'
                        type='button'
                        onClick={() => dispatch(setReviewModal(false))}>
                        <AiOutlineCloseCircle />
                    </button>
                </div>
                <div className='p-6'>
                    <div className='flex items-center justify-center gap-x-4'>
                        <img
                            src={user?.image}
                            alt={user?.accountType}
                            loading='lazy'
                            className="aspect-square w-[60px] rounded-full object-cover"
                        />
                        <div>
                            <p className='font-semibold text-richblack-5'>
                                {user?.firstName} {user?.lastName}
                            </p>
                            <p className='text-sm text-richblack-100'>
                                Your feedback will be posted publicly
                            </p>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)} className="mt-6 flex flex-col items-center">
                        <div>
                            <StarRatings
                                rating={rating}
                                changeRating={changeRatingHandler}
                                numberOfStars={5}
                                starDimension={'30px'}
                                starSpacing={'1px'}
                                starRatedColor={'#FFD60A'}
                                starEmptyColor={'#6E727F'}
                                starHoverColor={'#FFD60A'}
                                name='rating'
                            />
                        </div>
                        <div className='flex w-11/12 flex-col space-y-2'>
                            <label className='w-full'>
                                <p className='text-[0.875rem] leading-[1.375rem] text-sm text-richblack-5 mb-1'>Add your Experience <sub className='text-pink-200'>*</sub></p>
                                <textarea
                                    className='w-full p-[12px] bg-richblack-700 rounded-[0.5rem] h-40 text-richblack-5 outline-none'
                                    style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                    placeholder='Add your Experience here'
                                    name='recourseExperienceview'
                                    id='courseExperience'
                                    {...register("courseExperience", { required: true })}
                                />
                                {errors.courseExperience && <span className='text-sm text-pink-200'>Your feedback is important for us</span>}
                            </label>
                        </div>
                        <div className='mt-6 flex w-11/12 justify-end gap-x-2'>
                            <button
                                className='flex cursor-pointer items-center gap-x-2 rounded-md bg-richblack-300 py-[8px] px-[20px] font-semibold text-richblack-900'
                                type='button'
                                onClick={() => dispatch(setReviewModal(false))}>
                                Cancel
                            </button>
                            <button
                                className='flex items-center bg-yellow-50 cursor-pointer gap-x-2 rounded-md py-2 px-5 font-semibold text-richblack-900 undefined'
                                type='submit'>
                                {reviewUpdating._id ? "Update" : "Post"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default CourseReviewModal;